// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import FilterSearch from '@atlassian/jira-common-components-filter-search/src/main.tsx';
import type { AnalyticsData } from '../../state/analytics/types.tsx';

type Props = {
	value: string;
	onChange: (value: string) => void;
	analyticsData: AnalyticsData;
	ariaLabel?: string;
};

// eslint-disable-next-line jira/react/no-class-components
export default class FilterView extends PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		value: '',
	};

	onChange = (value: string) => {
		this.props.onChange(value);
	};

	render() {
		const { value = '' } = this.props;

		return (
			<FilterSearch
				value={value}
				onChange={this.onChange}
				ariaLabelText={this.props.ariaLabel}
				hasAutoFocus
			/>
		);
	}
}
